import React, { useEffect, useState } from 'react';
import { useLang } from '../LanguageContext';
import './HomeNews.css';

const T = {
  title: { ko: <>메디로지스의<br/>최신 소식을 확인해 보세요</>,
           en: <>See the latest<br/>from MEDILOGIS</> },
  tag:   { ko: '보도자료', en: 'Press' },
  more:  { ko: '소식 전체보기 →', en: 'See all news →' },
  empty: { ko: '등록된 소식이 없습니다.', en: 'No news yet.' },
};

// DB 제목 뒤에 "  [출처] 경기신문 (http...)" 같은 꼬리가 붙어 있어 화면에서는 떼어낸다
function cleanTitle(s) {
  if (!s) return '';
  return String(s).split('[출처]')[0].replace(/\s+/g, ' ').trim();
}

const COUNT = 3;

function HomeNews() {
  const { lang } = useLang();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch('/api/notices?category=PRESS')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive) return;
        const list = Array.isArray(d) ? d : (d && (d.result || d.data)) || [];
        setRows(list.slice(0, COUNT));
      })
      .catch(() => { if (alive) setRows([]); });
    return () => { alive = false; };
  }, []);

  return (
    <section className="hn" aria-label={lang === 'en' ? 'Latest news' : '최신 소식'}>
      <div className="hn-inner">
        <h2 className="hn-title">{T.title[lang]}</h2>
        <div className="hn-list">
          {rows === null && <div className="hn-empty">&nbsp;</div>}
          {rows !== null && rows.length === 0 && <div className="hn-empty">{T.empty[lang]}</div>}
          {rows !== null && rows.map((n) => {
            // 보도자료 페이지와 동일하게 사이트 안에서 본문을 연다
            const title = cleanTitle(lang === 'en' && n.TITLE_EN ? n.TITLE_EN : n.TITLE);
            const inner = (
              <>
                <span className="tag">{T.tag[lang]}</span>
                <span className="title" title={title}>{title}</span>
                <span className="arrow">→</span>
              </>
            );
            return (
              <a className="hn-row" key={n.IDX} href={`/news/press?idx=${n.IDX}`}>{inner}</a>
            );
          })}
        </div>
        <a className="hn-more" href="/news/press">{T.more[lang]}</a>
      </div>
    </section>
  );
}

export default HomeNews;
